module.exports = __webpack_public_path__ + "img/11.27c3efe5.png";